import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import type { GetPaymentAccountBalanceReportResponse } from '@shared/api/rest/accounts';
import { AmountUtils, DateUtils } from '@shared/utils';
import { Table, TableCellType } from '@shared/widgets';

interface IAccountTableProps {
  isLoading?: boolean;
  accounts: GetPaymentAccountBalanceReportResponse[];
  currentPage: number;
  totalItemCount: number;
  countItemPage: number;
  onChangePage: (pageNumber: number) => void;
  onChangeCountItemPage: (pageNumber: number) => void;
}
export const DepositAccountTable = (props: IAccountTableProps) => {
  const { t } = useTranslation('reports');

  const columns = useMemo(
    () => [
      t('payment.account.columns.date'),
      t('payment.account.columns.accountNumber'),
      t('payment.account.columns.accountName'),
      t('payment.account.columns.currency'),
      t('payment.account.columns.availableBalance'),
      t('payment.account.columns.blockedBalance'),
      t('payment.account.columns.totalBalance'),
    ],
    [t],
  );
  return (
    <Table
      isLoading={props.isLoading}
      columns={columns}
      items={props.accounts.map((x) => [
        { type: TableCellType.Text, value: DateUtils.formatDate(x.dateCreated) },
        { type: TableCellType.Text, value: x.accountNumber.replaceAll('X', '*') },
        { type: TableCellType.Text, value: x.accountName || `*${x.accountNumber.slice(-4)}` },
        { type: TableCellType.Text, value: x.currency.toUpperCase() },
        { type: TableCellType.Text, value: AmountUtils.transformToAmountWithCurrency(x.availableBalance, x.currency) },
        { type: TableCellType.Text, value: AmountUtils.transformToAmountWithCurrency(x.blockedBalance, x.currency) },
        { type: TableCellType.Text, value: AmountUtils.transformToAmountWithCurrency(x.totalBalance, x.currency) },
      ])}
      pagination={{
        currentPage: props.currentPage,
        totalItemCount: props.totalItemCount,
        countItemPage: props.countItemPage,
        onChangePage: props.onChangePage,
        onChangeCountItemPage: props.onChangeCountItemPage,
      }}
      isScrollable
    />
  );
};
